export class ProfileAddress {
  construct() {
    (this.ID = 0),
      (this.ProfileID = 0),
      (this.Address1 = ''),
      (this.Address2 = ''),
      (this.City = ''),
      (this.State = ''),
      (this.Zip = ''),
      (this.ZipExt = ''),
      (this.County = ''),
      (this.Country = ''),
      (this.AddressTypeID = 0),
      (this.AddressType = ''),
      (this.ProfileDefault = false),
      (this.StartDate = new Date()),
      (this.EndDate = new Date()),
      (this.Descr = ''),
      (this.DateCreated = new Date()),
      (this.DateChanged = new Date());
  }
  ID: number;
  ProfileID: number;
  Address1: string;
  Address2: string;
  City: string;
  State: string;
  Zip: string;
  ZipExt: string;
  County: string;
  Country: string;
  AddressTypeID: number;
  AddressType: string;
  ProfileDefault: boolean;
  StartDate: Date;
  EndDate: Date;
  Descr: string;
  DateCreated: Date;
  DateChanged: Date;
}
